<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,5C11.72,5,11.47,5.11,11.29,5.29C11.29,5.29,8,8.59,8,8.59C8,8.59,4.71,5.29,4.71,5.29C4.53,5.11,4.28,5,4,5C3.45,5,3,5.45,3,6C3,6.28,3.11,6.53,3.29,6.71C3.29,6.71,7.29,10.71,7.29,10.71C7.47,10.89,7.72,11,8,11C8.280000000000001,11,8.530000000000001,10.89,8.71,10.71C8.71,10.71,12.71,6.71,12.71,6.71C12.89,6.53,13,6.28,13,6C13,5.45,12.55,5,12,5C12,5,12,5,12,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ChevronDown',
} as DefineComponent
</script>
